import {
  generatePath as generateRoutePath,
  useParams as useRouterParams,
} from "react-router";

type PathParams<Path> = Path extends `:${infer Param}/${infer Rest}`
  ? Param | PathParams<Rest>
  : Path extends `:${infer Param}`
    ? Param
    : Path extends `${infer _Prefix}:${infer Rest}`
      ? PathParams<`:${Rest}`>
      : never;

type PathArgs<TPath, TParams = { [K in PathParams<TPath>]: string }> = TParams;

export const routes = {
  selectClub: "/",
  clubs: "/klubbar",
  districts: "/distrikt",
  createClub: "/skapa-klubb",
  club: "/klubb/:clubId",
  member: "/klubb/:clubId/medlemmar/:memberId",
  members: "/klubb/:clubId/medlemmar",
  signMembership: "/klubb/:clubId/medlemmar/:memberId/signera",
  newMember: "/klubb/:clubId/ny-medlem",
  constituentMeeting: "/klubb/:clubId/konstituerande-mote",
  statues: "/klubb/:clubId/stadgar",
  annualMeeting: "/klubb/:clubId/arsmote",
  annualReport: "/klubb/:clubId/verksamhetsberattelse",
  document: "/dokument/:docName",
  clubDocuments: "/klubb/:clubId/dokument/:docName",
  signedOut: "/utloggad",
  signatures: "/signaturer",
  orders: "/bestallningar",
  clubSignatures: "/klubb/:clubId/signaturer",
  clubSignatureLists: "/klubb/:clubId/signaturer/listor",
  validateClubSignatures: "/klubb/:clubId/signaturer/validera",
  importMembers: "/klubb/:clubId/medlemmar/importera",
  importMembersNew: "/klubb/:clubId/medlemmar/importera/ny",
  moveMembers: "/klubb/:clubId/medlemmar/flytta",
  sign: "/signera/:linkId",
  availabilitySettings: "/installningar",
  support: "/support",
} as const;

type Routes = typeof routes;
type RouteKey = keyof Routes;

export function useParams<TRouteKey extends RouteKey>() {
  return useRouterParams<PathParams<Routes[TRouteKey]>>();
}

export function generatePath<TRouteKey extends RouteKey>(
  route: TRouteKey,
  params: PathArgs<Routes[TRouteKey]>,
) {
  // @ts-ignore
  return generateRoutePath(routes[route], params);
}
